import { isRacker } from 'config';
import React from 'react';
import { proxyFetch } from 'proxy';
import _ from 'lodash';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import * as copilot from '@janus.team/janus-copilot';

const buildHeaders = (baseHeaders, { domainId }) => {
  const domainIdHeaders = domainId ? { 'x-tenant-id': domainId } : {};
  return _.merge({}, baseHeaders, domainIdHeaders);
};

const rejectOnNon200 = (res) => (
  res.ok ? Promise.resolve(res) : Promise.reject(res)
);

export const fetchCustomerAccounts = async (domainId, ...args) => {
  if (!domainId) { return {}; }
  
  const url = isRacker() ?
    `https://proxy.api.manage.rackspace.com/customer-admin/v3/customer_accounts?includeMetadata=true&limit=1000&domain=${domainId}` :
    `https://customer.api.rackspacecloud.com/v1/customer_accounts?limit=1000&includeMetadata=true&domain=${domainId}`;
  
  const options = { method: 'GET', headers: buildHeaders({}, { domainId }) };
  return proxyFetch(url, options)
    .then(rejectOnNon200)
    .then(_.method('parseJson'))
    .then(_.property('customerAccount'))
    .then((accounts) => _.orderBy(accounts, (account) => _.toLower(account?.name)));
};

const useDomainId = () => {
  const sessionContext = React.useContext(copilot.context.session);
  const domainIdFromParams = useParams()?.domainId;
  const domainIdFromSession = _.get(sessionContext, ['session', 'user', 'RAX-AUTH:domainId']);
  return domainIdFromParams || domainIdFromSession;
};

export const useCustomerAccountsQuery = () => {
  const domainId = useDomainId(); 
  return useQuery(['customer-accounts', domainId], (...args) => fetchCustomerAccounts(domainId, ...args), { retry: false });
};